import React, { useState } from "react";
import { Link } from "react-router-dom";
import api from "../services/api";
import AuthLayout from "../components/auth/AuthLayout";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.error || "Failed to send reset email.");
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <AuthLayout>
        <div className="text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#16A34A" strokeWidth="2"><path d="m9 12 2 2 4-4"/><circle cx="12" cy="12" r="10"/></svg>
          </div>
          <h1 className="text-[28px] font-bold text-gray-900 mb-2 font-body">Check your email</h1>
          <p className="text-[15px] text-gray-500 mb-6 font-body">We've sent a password reset link to <strong>{email}</strong></p>
          <Link to="/login" className="text-primary font-semibold hover:underline text-[14px]">Back to Login</Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout>
      <h1 className="text-[32px] font-bold text-gray-900 mb-2 font-body">Forget Password</h1>
      <p className="text-[15px] text-gray-500 mb-8 font-body">Enter your Credentials to access your account</p>

      {error && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-[13px] text-red-600">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-5">
          <label className="block text-[14px] font-medium text-gray-900 mb-1.5">Email address</label>
          <input type="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} required
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg text-[14px] text-gray-700 placeholder-gray-400 outline-none focus:border-primary transition-colors font-body" />
        </div>
        <button type="submit" disabled={loading}
          className="w-full py-3 bg-primary text-white rounded-lg font-semibold text-[15px] hover:bg-primary-dark transition-colors font-body disabled:opacity-60 mb-6">
          {loading ? "Sending..." : "Submit"}
        </button>
      </form>

      <p className="text-center text-[14px] text-gray-600 font-body">
        Don't have an account?{" "}<Link to="/signup" className="text-primary font-semibold hover:underline">Sign Up</Link>
      </p>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
